import Progressbar from "src/components/Progressbar";
import PanelLayout from "src/Layout/PanelLayout";
import Title from "src/components/Title";
import TextInput from "src/components/Form/TextInput";
import TextAreaInput from "src/components/Form/TextAreaInput";
import Button from "src/components/Form/Button";
import useFormFields from "src/hooks/useFormFields";
import useTextArea from "src/hooks/useTextArea";
import { useEffect, useState } from "react";
import DamanehayeErtebati from "src/components/Form/DamanehayeErtebati";
import FourInput from "src/components/Form/FourInput";
import MokhateratShoghli from "src/components/Form/MokhateratShoghli";
import AbzarhaVaTajhizat from "src/components/Form/AbzarhaVaTajhizat";
import CustomOptionBox from "src/components/Form/CustomOptionBox";
import CheckBox from "src/components/Form/CheckBox";
import CustomOptionSelect from "src/components/Form/CustomOptionSelect";
import CustomOptionSingleSelect from "src/components/Form/CustomOptionSingleSelect";
import Option from "src/components/Form/Option";
import FormCheckbox from "src/components/Form/FormCheckbox";
import Subheading from "src/components/Subheading";
import usePersistantState from "src/hooks/usePersistantState";

export default function JobAnalysisPage1({ handleStep, handleStepDown }) {

    const [masouliathayeShoghli, setMasouliathayeShoghli] = usePersistantState("masouliathayeShoghli", {
        "حفظ سلامت جسمی دیگران": {
            value: {},
            desc: ""
        },
        "نظارت و مسئولیت سرپرستی افراد": {
            value: {},
            desc: ""
        },
        "کنترل خطاها و آسیب‌های کاری": {
            value: {},
            desc: ""
        },
        "تهیه گزارشات حساس و مدیریتی": {
            value: {},
            desc: ""
        },
        "مدیریت مالی و منابع خاص": {
            value: {},
            desc: ""
        },
        "حفظ اموال و تجهیزات ویژه": {
            value: {},
            desc: ""
        },
        "حفظ و مدیریت اسناد و اطلاعات": {
            value: {},
            desc: ""
        },
        "مدیریت کمیته‌ها و شوراها": {
            value: {},
            desc: ""
        },
        "تعامل با مشتریان داخلی یا خارجی": {
            value: {},
            desc: ""
        },
        "حضور فیزیکی در محل کار": {
            value: {},
            desc: ""
        },
        "حفظ و نگهداری مواد و محصولات": {
            value: {},
            desc: ""
        },
    })

    const [mokhateratShoghli1, setMokhateratShoghli1] = usePersistantState("mokhateratShoghli1", {
        "برخورد اجسام با بدن": {
            value: {},
            desc: ""
        },
        "سقوط از ارتفاع": {
            value: {},
            desc: ""
        },
        "بریدگی": {
            value: {},
            desc: ""
        },
        "شکستگی": {
            value: {},
            desc: ""
        },
        "سوختگی": {
            value: {},
            desc: ""
        },
        "برق گرفتگی": {
            value: {},
            desc: ""
        },
    })
    const [mokhateratShoghli2, setMokhateratShoghli2] = usePersistantState("mokhateratShoghli2", {
        "صدمات سطحی": {
            value: {},
            desc: ""
        },
        "صدمات جدی": {
            value: {},
            desc: ""
        },
        "نقص عضو جزئی": {
            value: {},
            desc: ""
        },
        "نقص عضو کلی": {
            value: {},
            desc: ""
        },
        "ازکارافتادگی": {
            value: {},
            desc: ""
        },
        "ابتلا بیماری‌ها": {
            value: {},
            desc: ""
        },
    })
    const [mokhateratShoghli3, setMokhateratShoghli3] = usePersistantState("mokhateratShoghli3", {
        "دود، گازها و بخارات": {
            value: {},
            desc: ""
        },
        "محیط کثیف": {
            value: {},
            desc: ""
        },
        "گرد و غبار": {
            value: {},
            desc: ""
        },
        "سرو صدا": {
            value: {},
            desc: ""
        },
        "رطوبت، گرما و سرما": {
            value: {},
            desc: ""
        },
        "نور (کم یا شدید)": {
            value: {},
            desc: ""
        },
        "بوی نامطبوع": {
            value: {},
            desc: ""
        },
        "تنهایی": {
            value: {},
            desc: ""
        },
        "لرزش و ارتعاش": {
            value: {},
            desc: ""
        },
        "استرس و فشارهای روحی و روانی": {
            value: {},
            desc: ""
        }
    })
    const [mokhateratShoghli4, setMokhateratShoghli4] = usePersistantState("mokhateratShoghli4", {
        "حمل دستی  بار": {
            value: {},
            desc: ""
        },
        "جابجایی بار": {
            value: {},
            desc: ""
        },
        "هل دادن و كشیدن اجسام": {
            value: {},
            desc: ""
        },
        "كار در حالتها و وضعیتهای نامناسب": {
            value: {},
            desc: ""
        },
        "خیره شدن به کامپیوتر و مشکل گردن": {
            value: {},
            desc: ""
        },
        "ایستادن طولانی مدت": {
            value: {},
            desc: ""
        },
    })

    const [damanehayeErtebati, setDamanehayeErtebati] = usePersistantState("damanehayeErtebati", {
        "كاركنان دفتری  نظیر كارمندان، منشی ها و...": {
            value: {},
            desc: ""
        },
        "كاركنان نیمه حرفه ای نظیر تكنسین ها ،  كارشناسان و...": {
            value: {},
            desc: ""
        },
        "افراد حرفه ای نظیر مشاوران، مهندسان خبره، كارشناسان مسئول و...": {
            value: {},
            desc: ""
        },
        "روسای ادارت و سرپرستان": {
            value: {},
            desc: ""
        },
        "مدیران میانی(سطوح مدیریت)": {
            value: {},
            desc: ""
        },
        "معاونین  و قائم مقام مدیر عامل": {
            value: {},
            desc: ""
        },
        "مدیرعامل و اعضای هیئت مدیره": {
            value: {},
            desc: ""
        },
        "حسابرسان": {
            value: {},
            desc: ""
        },
        "پیمانكاران و مدیران شركتهای خصوصی": {
            value: {},
            desc: ""
        },
        "نیروی انتظامی و نهادهای حقوقی": {
            value: {},
            desc: ""
        },
        "موسسات آموزشی و پژوهشی": {
            value: {},
            desc: ""
        },
        "بانك ها و موسسات مالی و اعتباری": {
            value: {},
            desc: ""
        },
        "اقشار مختلف مردم در مجامع ، مراسم ها و...": {
            value: {},
            desc: ""
        },
        "افراد و موسسات خارجی": {
            value: {},
            desc: ""
        },
        "مسئولین و مدیران ارشدكشوری": {
            value: {},
            desc: ""
        }
    })

    const [damanehayeErtebatiDakhel, setDamanehayeErtebatiDakhel] = usePersistantState("damanehayeErtebatiDakhel", {
        "": {
            value: {},
            desc: ""
        }
    })

    const [damanehayeErtebatiKharej, setDamanehayeErtebatiKharej] = usePersistantState("damanehayeErtebatiKharej", {
        "": {
            value: {},
            desc: ""
        }
    })

    const [abzarhaVaTajhizat, setAbzarhaVaTajhizat] = usePersistantState("abzarhaVaTajhizat", {
        "میز مدیریتی 8 نفره": false,
        "پرینتر": false,
        "گاو صندوق": false,
        "اتاق 20 متری جدا": false,
        "میز کارشناسی": false,
        "فاکس": false,
        "مهر شرکت": false,
        "تاق 20 متری دو نفره": false,
        "میز کارمندی": false,
        "اسکنر": false,
        "بیسیم / دوربین": false,
        "اتاق 20 متری سه نفره": false,
        "کمد و کتابخانه": false,
        "کامپیوتر": false,
        "لپ تاپ/ تبلت": false,
        "پارتیشن چهار نفر به بالا": false,
        "میز کنفرانس 4 نفره": false,
        "دستگاه فتوکپی بزرگ": false,
        "خط تلفن موبایل": false,
        "ملزومات اداری": false,
        "صندلی طبی": false,
        "یخچال": false,
        "دستگاه تلفن مدیریتی": false,
        "نوشت افزار": false,
        "میز عسلی کشو دار": false,
        "تلویزیون": false,
        "رخت آویز": false,
        "کازیه": false,
        "میز جلوی مبلی": false,
        "وایت برد / اسمارت برد": false,
        "خودروی شرکت": false,
        "پرچم سازمانی": false,
        "مبل": false,
        "ویدیو پروژکتور": false,
        "موتور سیکلت": false,
        "ساعت": false,
    })

    const [doorkari, setDoorkari] = usePersistantState("doorkari", {
        "میزان وابستگی وظایف شغل به حضور فیزیکی در محل کار و زمان‌بندی مشخص چقدر است؟": {
            value: {},
            desc: ""
        },
        "تا چه حد اطلاعات مورد نیاز برای انجام وظایف از طریق سامانه‌های دیجیتال قابل دسترسی و مدیریت است؟": {
            value: {},
            desc: ""
        },
        "میزان ضرورت تعامل حضوری با همکاران، مدیران یا ارباب‌رجوع در انجام وظایف چقدر است؟": {
            value: {},
            desc: ""
        },
        "تا چه حد وظایف شغل مبتنی بر پردازش، تحلیل یا مدیریت اطلاعات دیجیتال است؟": {
            value: {},
            desc: ""
        },
        "میزان استقلال شاغل در نحوه انجام وظایف و تمرکز بر خروجی نهایی چقدر است؟": {
            value: {},
            desc: ""
        },
        "تا چه حد ابزارها و زیرساخت‌های فناوری اطلاعات برای انجام وظایف این شغل از راه دور فراهم و قابل استفاده هستند؟": {
            value: {},
            desc: ""
        }
    })

    /* vazayef takhasosi shoghl */
    const { fields, handleChange } = useFormFields({}, "sayereAbzarVaTajhizatFields")
    const [tasks, setTasks] = usePersistantState("sayereAbzarVaTajhizat", []);
    const [change, setChange] = useState(true);
    const addTask = () => {
        if (taskInputs.length < 14) {
            const newTasks = tasks;
            newTasks.push((tasks.length) + 1);
            setTasks(newTasks);
            setChange(!change);
        }
    }
    const handleDelete = (index) => {
        let newTask = tasks;
        newTask.splice(index, 1);
        setTasks(newTask);
        setChange(!change);
    }
    const taskInputs = tasks.map((task, index) => {
        if (index + 1 == tasks.length) {
            return (<TextInput value={fields[`ابزار و تجهیزات ${index + 2}`]} inputName={`ابزار و تجهیزات ${index + 2}`} label=" " index={index} key={index} placeholder={`وظیفه ${index + 2}`} handleChange={handleChange} handleDelete={handleDelete} isLast={true} />)
        } else {
            return (<TextInput value={fields[`ابزار و تجهیزات ${index + 2}`]} inputName={`ابزار و تجهیزات ${index + 2}`} label=" " index={index} key={index} placeholder={`وظیفه ${index + 2}`} handleChange={handleChange} handleDelete={handleDelete} />)
        }
    })
    /* vazayef takhasosi shoghl */


    return (
        <PanelLayout>
            <Title title="تجزیه و تحلیل شغل" />
            <Progressbar activePart={1} handleStep={handleStep} />
            <div className="bg-white p-10 mx-28 shadow-lg border border-gray-200 rounded-lg">



                {/* مسئولیت های شغلی */}
                <Subheading title="مسئولیت های شغلی" isFirst={true} />
                <FormCheckbox state={masouliathayeShoghli} setState={setMasouliathayeShoghli} newButtonLabel="افزودن مورد جدید" />
                {/* مسئولیت های شغلی */}


                <Subheading title="قابلیت دورکاری" isFirst={false} />
                <FormCheckbox state={doorkari} setState={setDoorkari} gozineType={2} />


                {/* مخاطرات شغلی */}
                <Subheading title="شناسایی مخاطرات شغلی" />
                <div className="mt-5 mb-4 text-[14px] text-[#7A7A7A]">
                    الف) احتمال مواجهه با عوامل مكانیكی زیان آور دراین  شغل چقدر است؟
                </div>
                <FormCheckbox type={2} state={mokhateratShoghli1} setState={setMokhateratShoghli1} newButtonLabel="افزودن جدید" />
                <div className="text-[14px] text-[#7A7A7A] mt-5 mb-4">
                    ب)  احتمال ایجاد ناتوانی های ذیل در این شغل چقدر است ؟
                </div>
                <FormCheckbox type={2} state={mokhateratShoghli2} setState={setMokhateratShoghli2} newButtonLabel="افزودن جدید" />
                <div className="text-[14px] text-[#7A7A7A] mt-5 mb-4">
                    ج)  احتمال مواجهه با عوامل زیان‌آور در این شغل چقدر است ؟
                </div>
                <FormCheckbox type={2} state={mokhateratShoghli3} setState={setMokhateratShoghli3} newButtonLabel="افزودن جدید" />
                <div className="text-[14px] text-[#7A7A7A] mt-5 mb-4">
                    د) احتمال مواجهه با عوامل ارگونومیكی زیان آور دراین شغل چقدر است ؟
                </div>
                <FormCheckbox type={2} state={mokhateratShoghli4} setState={setMokhateratShoghli4} newButtonLabel="افزودن جدید" />
                {/* مخاطرات شغلی */}




                {/* دامنه های ارتباطی */}
                <Subheading title="دامنه های ارتباطی" subTitle="میزان ارتباط متصدی این شغل با هركدام از اشخاص زیر تا چه اندازه باید باشد؟" />
                <FormCheckbox state={damanehayeErtebati} setState={setDamanehayeErtebati} />
                <div className="mt-10 text-[14px] text-[#7A7A7A]">
                    متصدی این شغل با چه كسانی در داخل سازمان بایستی ارتباط داشته باشد؟( ذكر عنوان پستی یا جایگاه سازمانی مربوطه)
                </div>
                <FormCheckbox state={damanehayeErtebatiDakhel} setState={setDamanehayeErtebatiDakhel} newButtonLabel="افزودن جدید" />
                <div className="mt-10 text-[14px] text-[#7A7A7A]">
                    متصدی این شغل با چه كسانی در خارج سازمان  بایستی ارتباط داشته باشد؟( ذكر عنوان پست، جایگاه ، سازمان، نهاد و...)
                </div>
                <FormCheckbox state={damanehayeErtebatiKharej} setState={setDamanehayeErtebatiKharej} newButtonLabel="افزودن جدید" />
                {/* دامنه های ارتباطی */}




                {/* ابزارها */}
                <Subheading title="ابزارها و تجهیزات" />
                <div className="mt-10">
                    <AbzarhaVaTajhizat options={abzarhaVaTajhizat} setOptions={setAbzarhaVaTajhizat} />
                    <div className="mt-10">
                        <TextInput value={fields[`ابزار و تجهیزات ${1}`]} placeholder="سایر ابزار و تجهیزات که در لیست بالا نیست در این قسمت باید وارد شود" inputName="ابزار و تجهیزات 1" handleChange={handleChange} />
                        {taskInputs}
                        <div className="flex items-center mb-5">
                            <div className="inline-block text-right text-gray-500"></div>
                            <button onClick={addTask}
                                className="flex w-[250px] justify-center items-center rounded-lg border-2 border-gray-400 placeholder-gray-300 outline-none focus:border-main-color hover:bg-[#5B5CFF] hover:text-white transition duration-300">
                                <span className="text-yellow-500 font-extrabold text-[1.3rem] m-2">+</span>
                                افزودن جدید
                            </button>
                        </div>
                    </div>
                </div>
                {/* ابزارها */}





                <div className="flex flex-row justify-center items-center mt-10">
                    <Button isPrevious={true} title="مرحله قبل" direction="center" handleClick={(event) => handleStepDown()} color="#f9b302" />
                    <Button title="ثبت اطلاعات و تکمیل فرم بعدی" direction="center" handleClick={(event) => handleStep()} color="#5B5CFF" />
                </div>
            </div>
        </PanelLayout>
    )
}